var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 870.4,
    height: 598.682,
    viewBox: "0 0 870.4 598.682",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-182.787 -183.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-237 346.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141-211",
    "data-name": "Path 141",
    d: "M827.279,436.053H539.012a5.345,5.345,0,0,1-5.338-5.338V184.207a5.345,5.345,0,0,1,5.338-5.338H827.279a5.345,5.345,0,0,1,5.338,5.338V430.714a5.344,5.344,0,0,1-5.338,5.338ZM539.012,181a3.207,3.207,0,0,0-3.2,3.2V430.714a3.207,3.207,0,0,0,3.2,3.2H827.279a3.206,3.206,0,0,0,3.2-3.2V184.207a3.207,3.207,0,0,0-3.2-3.2Z",
    transform: "translate(-44.905)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 21.745,
    cy: 21.745,
    r: 21.745,
    transform: "translate(517.152 370.472)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142-212",
    "data-name": "Path 142",
    d: "M634.024,377.72a3.624,3.624,0,0,0,0,7.248H804.88a3.624,3.624,0,0,0,0-7.248Z",
    transform: "translate(-44.905)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143-213",
    "data-name": "Path 143",
    d: "M634.024,399.466a3.624,3.624,0,0,0,0,7.248h73.52a3.624,3.624,0,0,0,0-7.248Z",
    transform: "translate(-44.905)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154-214",
    "data-name": "Path 154",
    d: "M895.768,350.074H607.5a5.344,5.344,0,0,1-5.338-5.338V218.229a5.344,5.344,0,0,1,5.338-5.338H895.768a5.344,5.344,0,0,1,5.338,5.338V344.736A5.344,5.344,0,0,1,895.768,350.074Z",
    transform: "translate(-44.905)",
    fill: "#b11977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155-215",
    "data-name": "Path 155",
    d: "M666.206,256.985a3.624,3.624,0,0,0,0,7.248H837.063a3.624,3.624,0,0,0,0-7.248Z",
    transform: "translate(-44.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156-216",
    "data-name": "Path 156",
    d: "M666.206,277.985a3.624,3.624,0,0,0,0,7.248H837.063a3.624,3.624,0,0,0,0-7.248Z",
    transform: "translate(-44.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157-217",
    "data-name": "Path 157",
    d: "M666.206,298.731a3.624,3.624,0,0,0,0,7.248h73.52a3.624,3.624,0,0,0,0-7.248Z",
    transform: "translate(-44.905)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 870.4,
    height: 2,
    transform: "translate(182.787 779.636)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(100 164.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138-218",
    "data-name": "Path 138",
    d: "M883.279,615.053H595.012a5.345,5.345,0,0,1-5.338-5.338V538.207a5.345,5.345,0,0,1,5.338-5.338H883.279a5.345,5.345,0,0,1,5.338,5.338v71.507A5.345,5.345,0,0,1,883.279,615.053ZM595.012,535a3.207,3.207,0,0,0-3.2,3.2v71.507a3.207,3.207,0,0,0,3.2,3.2H883.279a3.206,3.206,0,0,0,3.2-3.2V538.207a3.206,3.206,0,0,0-3.2-3.2Z",
    transform: "translate(-44.906)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 21.745,
    cy: 21.745,
    r: 21.745,
    transform: "translate(573.152 549.472)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139-219",
    "data-name": "Path 139",
    d: "M690.024,556.72a3.624,3.624,0,0,0,0,7.248H860.88a3.624,3.624,0,0,0,0-7.248Z",
    transform: "translate(-44.906)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140-220",
    "data-name": "Path 140",
    d: "M690.024,578.466a3.624,3.624,0,0,0,0,7.248h73.52a3.624,3.624,0,0,0,0-7.248Z",
    transform: "translate(-44.906)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "matrix(0.914, 0.407, -0.407, 0.914, 266.183, -179.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135-221",
    "data-name": "Path 135",
    d: "M811.279,721.053H523.012a5.345,5.345,0,0,1-5.338-5.338V644.207a5.344,5.344,0,0,1,5.338-5.338H811.279a5.345,5.345,0,0,1,5.338,5.338v71.507a5.345,5.345,0,0,1-5.338,5.338ZM523.012,641a3.207,3.207,0,0,0-3.2,3.2v71.507a3.207,3.207,0,0,0,3.2,3.2H811.279a3.206,3.206,0,0,0,3.2-3.2V644.207a3.207,3.207,0,0,0-3.2-3.2Z",
    transform: "translate(112.094 -174.499)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 21.745,
    cy: 21.745,
    r: 21.745,
    transform: "translate(658.152 480.973)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136-222",
    "data-name": "Path 136",
    d: "M618.024,662.72a3.624,3.624,0,0,0,0,7.248H788.88a3.624,3.624,0,1,0,0-7.248Z",
    transform: "translate(112.094 -174.499)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137-223",
    "data-name": "Path 137",
    d: "M618.024,684.466a3.624,3.624,0,1,0,0,7.248h73.52a3.624,3.624,0,0,0,0-7.248Z",
    transform: "translate(112.094 -174.499)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, -217.382, -42.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138-2-224",
    "data-name": "Path 138",
    d: "M883.279,615.053H595.012a5.345,5.345,0,0,1-5.338-5.338V538.207a5.345,5.345,0,0,1,5.338-5.338H883.279a5.345,5.345,0,0,1,5.338,5.338v71.507A5.345,5.345,0,0,1,883.279,615.053ZM595.012,535a3.207,3.207,0,0,0-3.2,3.2v71.507a3.207,3.207,0,0,0,3.2,3.2H883.279a3.206,3.206,0,0,0,3.2-3.2V538.207a3.206,3.206,0,0,0-3.2-3.2Z",
    transform: "translate(-44.906)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-2",
    "data-name": "Ellipse 18",
    cx: 21.745,
    cy: 21.745,
    r: 21.745,
    transform: "translate(573.152 549.472)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139-2-225",
    "data-name": "Path 139",
    d: "M690.024,556.72a3.624,3.624,0,0,0,0,7.248H860.88a3.624,3.624,0,0,0,0-7.248Z",
    transform: "translate(-44.906)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140-2-226",
    "data-name": "Path 140",
    d: "M690.024,578.466a3.624,3.624,0,0,0,0,7.248h73.52a3.624,3.624,0,0,0,0-7.248Z",
    transform: "translate(-44.906)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-1676 -1453.057)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(2259.759 1653.646)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 24.561,
    cy: 24.561,
    r: 24.561,
    transform: "translate(2268.868 1673.439)",
    fill: "#feb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159-227",
    "data-name": "Path 159",
    d: "M902.978,629.758s-45-8-74,2l8.5,67.5-2,11,60-2-4-11Z",
    transform: "translate(1427.781 1103.888)",
    fill: "#feb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160-228",
    "data-name": "Path 160",
    d: "M871.707,702.6a302.545,302.545,0,0,1-31-1.964,8.492,8.492,0,0,1-7.561-8.645l.73-31.567.085-.123c8.694-12.593,4.459-21.791,1.2-26.743a6.4,6.4,0,0,1-1.052-3.522h0c-.5-.7-.612.405-.3-.379a2.51,2.51,0,0,1,1.836-1.538l4.964-.992a2.5,2.5,0,0,1,2.858,1.651c1.668,4.977,8.169,20.991,23.066,20.987,12.445,0,17.089-17.611,17.367-21.681a2.5,2.5,0,0,1,2.493-2.322h6.2a2.617,2.617,0,0,1,2.066.934,2.48,2.48,0,0,1,.244,2.751c-7.076,13.01,3.265,33.6,3.37,33.8l.066.13-2.918,30.293a8.541,8.541,0,0,1-6.574,7.477C884.336,702.206,878.239,702.6,871.707,702.6Z",
    transform: "translate(1427.781 1103.888)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161-229",
    "data-name": "Path 161",
    d: "M814.6,772.888c-6.72,0-12.872-.74-17.76-2.489-5.81-2.079-9.458-5.441-10.844-10a13.2,13.2,0,0,1,1.606-11.673c8.595-12.87,38.421-16.5,42.423-16.929l2.12-17.667a8.531,8.531,0,0,1,8.307-7.486l50.232-.784a8.421,8.421,0,0,1,8.5,6.977l2.854,15.7L869.1,744.512l4.98,13.945-.325.217C864.115,765.1,836.392,772.887,814.6,772.888Z",
    transform: "translate(1427.781 1103.888)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162-230",
    "data-name": "Path 162",
    d: "M897.478,726.258s46-6,43,18-38,41-91,0l6-12s30,8,42,2Z",
    transform: "translate(1427.781 1103.888)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163-231",
    "data-name": "Path 163",
    d: "M856.478,735.258s0-12-10-11-28,2-28,2-6,4,2,6,32,12,32,12Z",
    transform: "translate(1427.781 1103.888)",
    fill: "#feb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164-232",
    "data-name": "Path 164",
    d: "M873.478,733.258s0-12,10-11,28,2,28,2,6,4-2,6-32,12-32,12Z",
    transform: "translate(1427.781 1103.888)",
    fill: "#feb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165-233",
    "data-name": "Path 165",
    d: "M933.4,730.985l-14.921-51.727s-3-18-6-35-14-15-14-15l-2,1v27l2,25,19.965,54.9a10.5,10.5,0,1,0,14.956-6.177Z",
    transform: "translate(1427.781 1103.888)",
    fill: "#feb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166-234",
    "data-name": "Path 166",
    d: "M832.478,631.258s-11-2-14,15-6,35-6,35l-14.921,51.727a10.5,10.5,0,1,0,14.956,6.177l19.965-54.9,2-25V634.494a3.618,3.618,0,0,0-2-3.236Z",
    transform: "translate(1427.781 1103.888)",
    fill: "#feb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167-235",
    "data-name": "Path 167",
    d: "M841.335,579.024a73.043,73.043,0,0,0,31.6,10.412l-3.331-3.991a24.48,24.48,0,0,0,7.561,1.5,8.281,8.281,0,0,0,6.75-3.159,7.7,7.7,0,0,0,.516-7.115,14.588,14.588,0,0,0-4.589-5.739,27.323,27.323,0,0,0-25.431-4.545,16.33,16.33,0,0,0-7.6,4.872,9.236,9.236,0,0,0-1.863,8.561",
    transform: "translate(1427.781 1103.888)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168-236",
    "data-name": "Path 168",
    d: "M868.084,553.421a75.485,75.485,0,0,0-27.463-17.759c-6.639-2.459-13.865-3.979-20.805-2.582s-13.5,6.2-15.44,13.008c-1.583,5.568.052,11.564,2.509,16.806s5.738,10.1,7.725,15.54A35.468,35.468,0,0,1,778.92,626c6.819.914,13.105,4.119,19.771,5.825s14.533,1.59,19.486-3.185c5.241-5.052,5.346-13.267,5.092-20.542l-1.13-32.445c-.192-5.515-.356-11.208,1.633-16.356s6.716-9.656,12.235-9.609c4.183.036,7.884,2.569,11.239,5.068s6.9,5.165,11.071,5.536,8.923-2.711,8.611-6.883",
    transform: "translate(1427.781 1103.888)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_133-237",
    "data-name": "Path 133",
    d: "M318.432,675.924a158.394,158.394,0,0,1-7.4,43.785c-.1.329-.211.653-.319.982H283.1c.029-.295.059-.624.088-.982,1.841-21.166-8.677-148.453-21.369-170.483C262.931,551.013,320.573,608.67,318.432,675.924Z",
    transform: "translate(697.642 58.945)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134-238",
    "data-name": "Path 134",
    d: "M284.933,719.709c-.231.329-.471.658-.717.982H263.5c.157-.28.339-.609.55-.982,3.422-6.176,13.551-24.642,22.953-43.785,10.1-20.572,19.374-41.924,18.593-49.652C305.838,628.014,312.83,681.148,284.933,719.709Z",
    transform: "translate(729.069 58.945)",
    fill: "#e6e6e6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalm);
export default __webpack_public_path__ + "static/media/Calm.49876ca04bc15a1bb542eee545fbdc4f.svg";
export { ForwardRef as ReactComponent };